import React, { useState } from "react";
import PropTypes from "prop-types";
import { FaUnlock } from "react-icons/fa";
import { Modal, Button, FormInput } from "components/common";

/**
 * Unlocks the Payment journal (APP) of a request Head of Finance / BOD already signed —
 * e.g. the PO is paid from another bank. The reason is kept on the request; saving the
 * change sends it to Head of Finance and BOD again.
 */
const JournalAdjustmentModal = ({ show, code, onHide, onSubmit }) => {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);

  const close = () => { setReason(""); onHide(); };
  const submit = async () => {
    if (busy || !reason.trim()) return;
    setBusy(true);
    try {
      if (await onSubmit(reason.trim())) close();
    } finally { setBusy(false); }
  };

  return (
    <Modal show={show} onHide={close} title={`Adjust the Payment journal of ${code}`} size="md"
      footer={<>
        <Button variant="secondary" size="sm" disabled={busy} onClick={close}>Cancel</Button>
        <Button variant="primary" size="sm" leftIcon={FaUnlock} loading={busy} aria-busy={busy}
          disabled={!reason.trim()} onClick={submit}>
          {busy ? "Unlocking…" : "Unlock to adjust"}
        </Button>
      </>}>
      <div className="geist-scope tw-space-y-3">
        <p className="tw-m-0 tw-text-sm tw-text-geist-fg-2">
          Head of Finance and BOD approved this payment as it is. Once you save a change, the request goes back to
          them to sign again. Nothing is sent again if you cancel without saving.
        </p>
        <FormInput label="Reason" type="textarea" rows={3} maxLength={500} required
          placeholder="e.g. Pay this PO from VCB instead of BIDV"
          value={reason} onChange={(e) => setReason(e.target.value)} />
      </div>
    </Modal>
  );
};

JournalAdjustmentModal.propTypes = {
  show: PropTypes.bool.isRequired,
  code: PropTypes.string,
  onHide: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default JournalAdjustmentModal;
